(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import DiabetesDataModule from './components/DiabetesDataModule';
import getTimelineGlucose from './timelineData/getTimelineGlucose';
import { Icons } from '@kailona/ui';
var _default = {
  id: 'plugin-diabetes',
  path: '/diabetes',
  name: t('ehr', 'Diabetes'),
  MenuModule: {
    name: t('ehr', 'Diabetes'),
    icon: {
      component: Icons.DiabetesIcon
    },
    priority: 60
  },
  WidgetModule: {
    name: t('ehr', 'Diabetes'),
    icon: {
      component: Icons.DiabetesIcon
    },
    priority: 60
  },
  DataModule: {
    Component: DiabetesDataModule
  },
  TimelineModule: [{
    name: t('ehr', 'Glucose'),
    color: '#7d3c98',
    icon: {
      component: Icons.DiabetesIcon,
      color: '#7d3c98'
    },
    getData: getTimelineGlucose
  }]
};
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(_default, "default", "/home/runner/html/nextcloud/apps/ehr/js/plugins/diabetes/src/index.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();